// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html[data-v-5365787b] {\n  scroll-behavior: smooth;\n}", ""]);
// Exports
module.exports = exports;
